import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import {
    getFiatCurrencies,
    getCryptocurrencies,
    updateFiatCurrency,
} from '@/services/exchange-rates.service'
import type {
    FiatCurrency,
    Cryptocurrency,
    UpdateFiatCurrencyRequest,
} from '@/types/exchange-rate'

/**
 * Get all fiat currencies
 */
export const useFiatCurrencies = () => {
    return useQuery<FiatCurrency[]>({
        queryKey: ['fiat-currencies'],
        queryFn: getFiatCurrencies,
        staleTime: 1000 * 60 * 5,
    })
}

/**
 * Get all cryptocurrencies
 */
export const useCryptocurrencies = () => {
    return useQuery<Cryptocurrency[]>({
        queryKey: ['cryptocurrencies'],
        queryFn: getCryptocurrencies,
        staleTime: 1000 * 60 * 10,
    })
}

/**
 * Update a fiat currency
 */
export const useUpdateFiatCurrency = () => {
    const queryClient = useQueryClient()

    return useMutation<
        FiatCurrency,
        unknown,
        { fiatId: string; data: UpdateFiatCurrencyRequest }
    >({
        mutationFn: ({ fiatId, data }) => updateFiatCurrency(fiatId, data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['fiat-currencies'] })
        },
    })
}
